<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-toolbar v-if="!disabled">
        <template v-slot:buttons>
          <vxe-button @click="productNameClick()" >添加预算</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table :data="budgetsList">
        <vxe-table-column min-width="100" field="feeBudgetCode" title="关联预算">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="fiscalYear" title="财年">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="budgetSubjectName" title="预算科目">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="companyName" title="公司主体">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="levelNum" title="优先级">
        </vxe-table-column>
        <vxe-table-column
          title="操作"
          width="100"
          show-overflow
          v-if="!disabled"
          key="操作"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="deletRow(row, rowIndex)">删除</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import request from '@/found/utils/request';
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'configProducts',
  components: {
    SelectConfig,
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        this.budgetsList = val || [];
      },
      deep: true,
    },
    disabled(val) {
      console.log('🚀 ~ disabled ~ val:', val);
    },
  },
  data() {
    return {
      budgetsList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.budgetsList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.budgetsList, 'budgetsList');
        this.budgetsList.splice(rowIndex, 1);
        this.$emit('input', this.budgetsList);
      });
    },
    deleteTable() {
      this.budgetsList = [];
      this.$emit('input', []);
    },
    // 打开点击弹窗产品名称
    productNameClick(index) {
      const params = {
        data: this.budgetsList,
        selectionList: [],
        functionCode: 'budgetsList',
        idKey: 'budgetsCode',
        noReset: true,
        paramData: {
          enableStatus: '009',
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    onGetSelect(val) {
      const data = this.getReset(val, [], 'id');
      this.budgetsList = this.getReset(this.budgetsList.concat(data), [], 'id');
      this.budgetsList = this.budgetsList.map((item, index) => ({
        budgetSubjectCode: item.budgetSubjectsCode,
        budgetSubjectName: item.budgetSubjectsName,
        companyCode: item.ext7,
        companyName: item.ext8,
        feeBudgetCode: item.feeBudgetCode,
        feeBudgetType: item.feeBudgetType,
        fiscalYear: item.ext1,
        levelNum: item.levelNum || index + 1,
      }));
      this.$emit('input', this.budgetsList);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },

  },
};
</script>

<style lang="less" scoped>
  .edit-table {
    padding-left: 50px;
    margin-left: 0 !important;
  }
</style>
